/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import toastr from 'toastr';
import ImageZoom from 'react-medium-image-zoom';
import { Base64 } from 'js-base64';
import { FaTrashAlt } from 'react-icons/fa';
import styled from 'styled-components';
import {
  FormGroup,
  Form,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { IMG_URL } from '../config';

import escapeChars from '../helpers/regex';
import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';
import { addAds, getSettings, deleteAds } from '../api/settings';
import { addHomeAdsSchema } from '../validations/index';

class HomeAds extends React.Component {
  constructor(props) {
    super(props);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.state = {
      loading: false,
      settings: '',
      lastAdded: null,
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUserId;
    const masterUser = user && (user.masterUserId || user.id);
    const data = await getSettings({ masterUser });
    this.setState({ settings: data.data.settings, masterUser });
  }

  async deleteHandler(home) {
    const { masterUser, settings } = this.state;
    const data = {
      home,
      type: 'home',
    };
    const res = await deleteAds(masterUser, data).then((result) => result, (error) => {
      console.log({ error });
      return error;
    });
    settings.ads.images = settings.ads.images.filter(
      (filterBanner) => filterBanner !== res.data.image,
    );
    this.setState({ settings });
    toastr.success('', 'Ads Deleted');
  }

  render() {
    const { intl } = this.props;
    const {
      loading, settings, masterUser,
    } = this.state;

    const adsText = intl.formatMessage({ id: 'ads' });
    const adsAddText = intl.formatMessage({ id: 'ads.add' });
    const adsAddedText = intl.formatMessage({ id: 'ads.added' });
    const homeAdsSettingsText = intl.formatMessage({ id: 'home.adssettings' });
    const supportVideoTagText = intl.formatMessage({ id: 'supportvideotag' });
    const overImageSize = intl.formatMessage({ id: 'ads.imageOverSize' });
    const overVideoSize = intl.formatMessage({ id: 'ads.videoOverSize' });

    return (
      <Row>
        <Col>
          <Formik
            enableReinitialize
            validationSchema={addHomeAdsSchema}
            onSubmit={async (data, { resetForm }) => {
              this.setState({ loading: true });
              const formData = new FormData();
              const imagefile = document.querySelector('#ads');
              formData.append('type', 'home');
              if (imagefile.files[0] !== undefined) {
                formData.append('ads', imagefile.files[0], escapeChars(imagefile.files[0].name));
              }
              const res = await addAds(masterUser, formData).then((result) => result, (error) => {
                console.log({ error });
                return { error };
              });
              if (res.error) {
                return toastr.error(intl.formatMessage({ id: 'error' }));
              }
              settings.ads.images.push(res.data.image);
              const output = document.getElementById('previewImage');
              output.src = '';
              imagefile.value = '';
              this.setState({ settings, loading: false, lastAdded: res.data.image });
              toastr.success('', adsAddedText);
            }}
          >
            {({
              values,
              errors,
              setFieldValue,
              handleBlur,
              handleSubmit,
              /* and other goodies */
            }) => (
              <Content title={homeAdsSettingsText}>
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="name">{adsText}</Label>
                      <Input
                        type="file"
                        name="ads"
                        id="ads"
                        placeholder={adsText}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          const output = document.getElementById('previewImage');

                          if (event.target.files[0]) {
                            if ((event.target.files[0].type === 'video/mp4' || event.target.files[0].type === 'video/mov') && event.target.files[0].size > 10000000) {
                              output.src = '';
                              output.value = '';
                              setFieldValue('ads', null);
                              return alert(overVideoSize);
                            }
                            if (!(event.target.files[0].type === 'video/mp4' || event.target.files[0].type === 'video/mov') && event.target.files[0].size > 1000000) {
                              output.src = '';
                              output.value = '';
                              setFieldValue('ads', null);
                              return alert(overImageSize);
                            }
                            console.log(event.target.files[0].type);

                            output.src = event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : '';
                            setFieldValue('ads', event.currentTarget.files[0]);
                          }
                        }}
                      />
                      {errors.ads && <FormError error={errors.ads} />}
                      <PreviewImg id="previewImage" src="" alt="" />
                    </FormGroup>
                    <SnipperButton type="submit" loading={loading} text={adsAddText} />
                    <Wrapper>
                      {' '}
                      {
                        settings && settings.ads.images.map((home, index) => {
                          let path;
                          try {
                            path = `${IMG_URL}${Base64.encode(masterUser)}/images/${home}`;
                          } catch (err) {
                            console.error(err);
                          }
                          const key = `home-${index}`;
                          return (
                            <ImageWrapper
                              key={key}
                            >
                              {
                                !(/^.*(\.mp4|\.mov)$/).test(home) ? (
                                  <ImageZoom
                                    image={{
                                      src: path,
                                      className: 'img',
                                      id: 'previewImage',
                                      style: { width: '80%', marginRight: '40px', height: 'auto' },
                                    }}
                                    zoomImage={{
                                      src: path,
                                    }}
                                  />
                                ) : (
                                  <Video controls>
                                      <source src={path} type="video/mp4" />
                                      <source src="movie.ogg" type="video/ogg" />
                                      {supportVideoTagText}
                                    </Video>
                                )
                              }
                              <DeleteButton onClick={() => this.deleteHandler(home)} />
                            </ImageWrapper>
                          );
                        })
                      }
                    </Wrapper>
                  </Form>
                </Content>
            )}
          </Formik>
        </Col>
      </Row>
    );
  }
}
const Wrapper = styled.div`
display: grid;
grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
grid-gap: 10px;
margin-top: 40px;
`;
const PreviewImg = styled.img`
  margin-top: 20px;
  width: 200px;
`;
const DeleteButton = styled(FaTrashAlt)`
  position: absolute;
  top: 0; 
  right: 20px;
  cursor: pointer;
`;
const ImageWrapper = styled.div`
  display: inline-block;
  position: relative;

`;
const Video = styled.video`
  width: 200px;
  height: 115px;
`;
const mapStateToProps = (state) => ({ user: state.auth.user });
export default injectIntl(connect(mapStateToProps)(HomeAds));
